// src/utils/colorUtils.ts
export function getContrastColor(hexColor: string): string {
    // Convert hex to RGB
    const r = parseInt(hexColor.slice(1, 3), 16) / 255
    const g = parseInt(hexColor.slice(3, 5), 16) / 255
    const b = parseInt(hexColor.slice(5, 7), 16) / 255

    // Calculate relative luminance
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b

    // Return black for light colors, white for dark colors
    return luminance > 0.5 ? 'var(--tb-primary)' : 'var(--tb-blushPrimary)'
}

// Update CSS variables
export function updateContrastColors() {
    const root = document.documentElement
    const style = getComputedStyle(root)

    // Get all your color variables
    const colors = {
        '--tb-primary': style.getPropertyValue('--tb-primary'),
        '--tb-blushPrimary': style.getPropertyValue('--tb-blushPrimary'),
        '--tb-fadedPrimary': style.getPropertyValue('--tb-fadedPrimary'),
        '--tb-lightPrimary': style.getPropertyValue('--tb-lightPrimary'),
        '--tb-link': style.getPropertyValue('--tb-link'),
        '--tb-mainHeading': style.getPropertyValue('--tb-mainHeading'),
        '--tb-lightGray': style.getPropertyValue('--tb-lightGray'),
        '--tb-text': style.getPropertyValue('--tb-text'),
        '--tb-textLight': style.getPropertyValue('--tb-textLight'),
        '--tb-green': style.getPropertyValue('--tb-green'),
        '--tb-lightGreen': style.getPropertyValue('--tb-lightGreen'),
        '--tb-white': style.getPropertyValue('--tb-white')
        // Add other colors as needed
    }

    // Update contrast colors
    Object.entries(colors).forEach(([varName, color]) => {
        const contrastColor = getContrastColor(color)
        root.style.setProperty(`${varName}-cc`, contrastColor)
    })
}

// Call on initial load
if (typeof window !== 'undefined') {
    updateContrastColors()
    // Optional: Update on theme changes
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', updateContrastColors)
}
